import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, FormControl, InputLabel } from '@mui/material';
import { useAuth } from '@contexts/AuthContext';
import BpmnModelerComponent from '@components/workflow/BpmnModeler';
import CustomerSelect from '@components/customer/CustomerSelect';
import MessageDialog from '@components/workflow/messagedialog/MessageDialog';
import FormDialog from '@components/workflow/formdialog/FormDialog';

function WorkflowForm({ initialData, handleSubmit }) {
    const { t } = useTranslation();
    const { isSuperAdmin, getCurrentCustomerId } = useAuth();
    const bpmnModelerRef = useRef(null);
    const [customerId, setCustomerId] = useState(null);

    useEffect(() => {
        if (initialData?.customer_id) {
            setCustomerId(initialData.customer_id);
        }
    }, [initialData]);

    const exportDiagram = async () => {
        try {
            const xml = await bpmnModelerRef.current.exportDiagram();
            const data = {
                extractFromBpmn: true,
                bpmn: xml,
                customer_id: isSuperAdmin() ? customerId : getCurrentCustomerId(),
            };
            handleSubmit(data);
        } catch (error) {
            console.error('Error exporting diagram:', error);
        }
    }

    return (
        <Box sx={{
            height: {
                xs: 'calc(100vh - 218px)',
                sm: 'calc(100vh - 178px)',
            },
            minHeight: '300px'
        }}>
            <BpmnModelerComponent ref={bpmnModelerRef} bpmn={initialData?.bpmn} 
                customerId={isSuperAdmin() ? customerId : getCurrentCustomerId()} />
            <Box sx={{ mt: 2 }}>
                {(isSuperAdmin() || customerId) &&
                    <Button type="submit" variant="contained" color="primary" onClick={exportDiagram}>
                        {t('Save')}
                    </Button>
                }
                {(isSuperAdmin() && customerId) &&
                    <FormControl variant="standard" size="small" sx={{ ml: 4 }}>
                        <InputLabel id="customer-label">{t('Customer')}</InputLabel>
                        <CustomerSelect
                            labelId="customer-label"
                            autoWidth
                            value={customerId}
                            onChange={(e) => setCustomerId(e.target.value)}
                        />
                    </FormControl>
                }
            </Box>

            <MessageDialog initialData={initialData} />
            <FormDialog customerId={customerId} initialData={initialData} />
        </Box>
    );
}
export default WorkflowForm;